import {
  CircularProgress,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import {
  handleDependencyChange,
  handleDependencySwitch,
} from "../../../Redux/reducers/questionSlice";
import DependencyConditionFields from "./DependencyConditionFields";
import DependencyParentPicker from "./DependencyParentPicker";
import { useDependencyParentPicker } from "./useDependencyParentPicker";

type Props = {
  question: any;
};

const DependencyTab = ({ question }: Props) => {
  const { dependency }: { dependency: any } = question || {};

  const dispatch = useAppDispatch();

  const studyId = useAppSelector(({ question }) => question.studyId);
  const formId = useAppSelector(({ question }) => question.formId);
  const formCategory = useAppSelector(({ question }) => question.formCategory);
  const isPreview = useAppSelector(({ question }) => !question.editable);
  const isDependencyError = useAppSelector(
    ({ question }) => question.isDependencyError
  );
  const formLevel = useAppSelector(({ question }) => question.formLevel);

  const { isLoading, selectedQuestion } = useDependencyParentPicker({
    parentFormId: dependency?.parentFormId,
    parentQuestionId: dependency?.parentQuestionId,
    excludeQuestionId: question?.id,
    studyId,
    formCategory,
    formLevel,
    currentFormId: formId,
  });

  const onChange = (key: string, value: string | number) => {
    const convertToNum = key === "numberValue";
    dispatch(
      handleDependencyChange({
        key,
        value,
        convertToNum,
      })
    );
  };

  return (
    <Stack gap={2} py={1} sx={{ width: "100%" }}>
      {isDependencyError && (
        <Typography variant="caption" fontWeight="medium" color={"red"}>
          {isDependencyError}
        </Typography>
      )}

      <Stack gap={1}>
        <FormControlLabel
          disabled={isPreview}
          control={
            <Switch
              checked={!!dependency}
              onChange={(e) =>
                dispatch(handleDependencySwitch({ value: e.target.checked }))
              }
            />
          }
          label={
            <Typography variant="body1" fontWeight={"regular"}>
              Is this field dependent?
            </Typography>
          }
        />
      </Stack>

      {dependency && isLoading && (
        <Stack
          gap={1}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ width: "100%" }}
        >
          <CircularProgress />
        </Stack>
      )}

      {dependency && !isLoading && (
        <Stack gap={2}>
          <DependencyParentPicker
            parentFormId={dependency?.parentFormId}
            parentQuestionId={dependency?.parentQuestionId}
            excludeQuestionId={question?.id}
            studyId={studyId}
            formCategory={formCategory}
            formLevel={formLevel}
            currentFormId={formId}
            readOnly={isPreview}
            showFormPicker={
              formCategory === "visit" || formCategory === "survey"
            }
            onParentFormChange={(selectedFormId) =>
              onChange("parentFormId", selectedFormId)
            }
            onParentQuestionChange={(questionId) =>
              onChange("parentQuestionId", questionId)
            }
            disableQuestionIds={question?.id ? [question.id] : []}
          />

          <DependencyConditionFields
            dependency={dependency}
            selectedQuestion={selectedQuestion}
            readOnly={isPreview}
            onChange={onChange}
          />
        </Stack>
      )}
    </Stack>
  );
};
export default DependencyTab;
